import { Field } from 'Util/Query';

/** @namespace Pwa/Query/RewardsPointsForProduct/Query */
export class RewardsPointsForProductQuery {
    getRewardsPointsForProduct(productId) {
        const query = new Field('mstRewardsPointsForProduct')
            .addArgument('product_id', 'Int!', productId)
            .addFieldList(['points']);

        return query;
    }
}

export default new RewardsPointsForProductQuery();
